import { GetOneContactInDto, GetOneContactOutDto } from '../../../types/contact.dto'

export const GET_ONE_CONTACT = 'GET_ONE_CONTACT'
export const GET_ONE_CONTACT_SUCCESS = 'GET_ONE_CONTACT_SUCCESS'
export const GET_ONE_CONTACT_ERROR = 'GET_ONE_CONTACT_ERROR'
export const RESET_GET_ONE_CONTACT = 'RESET_GET_ONE_CONTACT'

export interface GetOneContact {
  type: typeof GET_ONE_CONTACT
  payload: GetOneContactOutDto
}

export interface GetOneContactSuccess {
  type: typeof GET_ONE_CONTACT_SUCCESS
  payload: GetOneContactInDto
}

export interface GetOneContactError {
  type: typeof GET_ONE_CONTACT_ERROR
  payload: string | boolean
}

export interface ResetGetOneContact {
  type: typeof RESET_GET_ONE_CONTACT
  payload: null
}

export interface State {
  data: GetOneContactInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOneContact | GetOneContactSuccess | GetOneContactError | ResetGetOneContact
